<template>
    <div class="rail-panel">
        <div class="rail-panel__head">
            <span class="rail-panel__title">Crédito</span>
            <span class="rail-panel__subject">{{ providerCredit?.nombre || '' }}</span>
        </div>
        <table class="rail-table">
            <tbody>
                <tr>
                    <td>Días de crédito</td>
                    <td>{{ providerCredit.diasCredito }}</td>
                </tr>
                <tr>
                    <td>Documento permitido</td>
                    <td>{{ providerCredit.documentoCredito }}</td>
                </tr>
                <tr>
                    <td>Límite de crédito</td>
                    <td>{{ providerCredit.limiteCreditoNatural }}</td>
                </tr>
                <tr class="red--text text--darken-4">
                    <td>Documentos pendientes</td>
                    <td>{{ providerCredit.numberDocument }}</td>
                </tr>
                <tr class="red--text text--darken-4">
                    <td>Cuentas pendientes</td>
                    <td>{{ providerCredit.debtNatural }}</td>
                </tr>
                <tr class="rail-table__row--balance">
                    <td>Saldo disponible</td>
                    <td>{{ providerCredit.balanceNatural }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import proveedorDataService from '@/service/catalogo/proveedor/proveedorDataService';

export default {
    name: 'DetailproviderCredit',
    props: {
        providerId: { type: Number, required: true }
    },
    data() {
        return {
            providerCredit: {},
            allowToSell: false
        }
    },
    methods: {
        getProviderCredit() {
            if (this.providerId) {
                proveedorDataService.getDetailCredit(this.providerId).then( result => {
                    this.providerCredit = result.data
                    this.$emit('providerCredit', this.providerCredit)

                })
            }
        }
    },
    watch: {
        providerId: {
            immediate: true,
            handler() {
                this.getProviderCredit();
            }
        }
    }
}
</script>
